import { Card, Dropdown } from "react-bootstrap";
import PrimerChart from "../components/primer-chart";
import KpiSection from "../components/KpiSection";
import { KPI_ICONS } from "../constants/kpiIcons";
import { KPI_COLORS } from "../constants/kpiColors";

export default function PrimerSection({
  data,
  limit,
  onChangeLimit,
  thn,
}) {
  return (
    <Card className="h-800 shadow-sm rounded-3 mb-3">
      <Card.Header className="d-flex justify-content-between align-items-center">
        <h6 className="fw-bold text-uppercase mb-0">
          {/* Grafik Sertifikasi Mutu Primer Tahun {thn} */}
          {/* Rekap Sertifikasi Mutu Primer */}
          Grafik Sertifikasi Mutu Primer Per Provinsi
        </h6>

        <Dropdown onSelect={(v) => onChangeLimit(Number(v))}>
          <Dropdown.Toggle size="sm" variant="light">
            Top {limit}
          </Dropdown.Toggle>

          <Dropdown.Menu>
            {[5, 10, 15, 20].map((v) => (
              <Dropdown.Item key={v} eventKey={v}>
                Top {v}
              </Dropdown.Item>
            ))}
          </Dropdown.Menu>
        </Dropdown>
      </Card.Header>

      <Card.Body>
        {
          data?.data?.length ? (
            <PrimerChart rekapPrimer={data.data} />
          ) : (
            <div className="text-center text-muted py-4">
              📭 Data belum tersedia
            </div>
          )
        }

        {/* ===== KPI ===== */}
        <h6 className="fw-bold text-uppercase mt-3 mb-4">
          {/* Grafik Sertifikasi Mutu Primer Tahun {thn} */}
          {/* Grafik Sertifikasi Mutu Primer Per Provinsi */}
          Rekap Sertifikasi Mutu Primer
        </h6>

        <KpiSection
          rekap={data?.rekap || {}}
          loading={!data}
          icons={KPI_ICONS}
          colors={KPI_COLORS}
        />
      </Card.Body >
    </Card >
  );
}
